import React, { useRef } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const GeneratedCard = ({ card }) => {

  const frontRef = useRef(null);
  const backRef = useRef(null);

  // CLEAN QR VALUE (fix wrong redirect issue)
  const qrUrl = "https://zuluwhiskeyshipping.com/";

  // REAL ATM CARD SIZE RATIO (ID-1)
  const cardSize = {
    width: 320,
    height: 200,
  };

  const downloadPDF = async () => {
    const pdf = new jsPDF("portrait", "mm", "a4");

    // ================= FRONT =================
    const frontCanvas = await html2canvas(frontRef.current, {
      scale: 3,
      useCORS: true,
    });

    const frontImg = frontCanvas.toDataURL("image/png");

    // centered like print sheet (NOT oversized)
    pdf.addImage(frontImg, "PNG", 45, 35, 120, 75);

    // ================= BACK =================
    pdf.addPage();

    const backCanvas = await html2canvas(backRef.current, {
      scale: 3,
      useCORS: true,
    });

    const backImg = backCanvas.toDataURL("image/png");

    pdf.addImage(backImg, "PNG", 45, 35, 120, 75);

    pdf.save(`${card.customer_name}-prepaid-card.pdf`);
  };

  return (
    <Box sx={{ mb: 5 }}>

      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          Generated Prepaid Card
        </Typography>

        <Button
          startIcon={<DownloadIcon />}
          variant="contained"
          onClick={downloadPDF}
          sx={{
            background: "linear-gradient(135deg,#C9A227,#E6C863)",
            fontWeight: "bold",
          }}
        >
          Download PDF
        </Button>
      </Box>

      <Grid container spacing={4}>

        {/* ================= FRONT ================= */}
        <Grid item xs={12} md={6}>
          <Box
            ref={frontRef}
            sx={{
              width: cardSize.width,
              height: cardSize.height,
              borderRadius: "14px",
              background: "linear-gradient(135deg,#000,#111827,#1f2937)",
              color: "#fff",
              p: 2.5,
              position: "relative",
              overflow: "hidden",
            }}
          >

            {/* TOP SECURITY BAR */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                background: "#000",
                textAlign: "center",
                py: 0.6,
                fontSize: 9,
                color: "#9ca3af",
                letterSpacing: 1,
              }}
            >
              This card is property of ZuluWhiskey Shopping Mall
            </Box>

            {/* HEADER ROW */}
            <Box display="flex" justifyContent="space-between" mt={2}>
              <Typography sx={{ fontSize: 16, fontWeight: 800 }}>
                ZULUWHISKEY
              </Typography>

              <CreditCardIcon sx={{ color: "#C9A227", fontSize: 26 }} />
            </Box>

            {/* SHOP ICON (replaces gold chip) */}
            <Box mt={1}>
              <ShoppingCartIcon sx={{ color: "#C9A227", fontSize: 24 }} />
            </Box>

            {/* ACCOUNT NUMBER */}
            <Typography
              sx={{
                mt: 2,
                fontSize: 16,
                letterSpacing: 2,
              }}
            >
              {card.account_number}
            </Typography>

            {/* CARD HOLDER */}
            <Box mt={2}>
              <Typography sx={{ color: "#9ca3af", fontSize: 10 }}>
                CARD HOLDER
              </Typography>
              <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
                {card.customer_name}
              </Typography>
            </Box>

            {/* QR CODE */}
            <Box
              sx={{
                position: "absolute",
                bottom: 10,
                right: 10,
                background: "#fff",
                p: 0.6,
                borderRadius: "6px",
              }}
            >
              <QRCodeCanvas value={qrUrl} size={60} />
            </Box>

          </Box>
        </Grid>

        {/* ================= BACK ================= */}
        <Grid item xs={12} md={6}>
          <Box
            ref={backRef}
            sx={{
              width: cardSize.width,
              height: cardSize.height,
              borderRadius: "14px",
              background: "linear-gradient(135deg,#111827,#000)",
              color: "#fff",
              p: 2.5,
              position: "relative",
            }}
          >

            {/* TOP BAR ONLY */}
            <Box
              sx={{
                height: 28,
                background: "#000",
                textAlign: "center",
                fontSize: 9,
                color: "#9ca3af",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ZuluWhiskey Secure Prepaid Card System
            </Box>

            {/* SIGNATURE AREA */}
            <Box
              sx={{
                background: "#fff",
                color: "#000",
                p: 1,
                borderRadius: "6px",
                mt: 3,
                fontSize: 11,
              }}
            >
              Authorized Signature
            </Box>

            {/* WEBSITE */}
            <Typography sx={{ mt: 2, fontSize: 11, color: "#9ca3af" }}>
              www.zuluwhiskey.com
            </Typography>

            {/* QR */}
            <Box
              sx={{
                position: "absolute",
                bottom: 10,
                right: 10,
                background: "#fff",
                p: 0.6,
                borderRadius: "6px",
              }}
            >
              <QRCodeCanvas value={qrUrl} size={55} />
            </Box>

          </Box>
        </Grid>

      </Grid>
    </Box>
  );
};

export default GeneratedCard;